import localStore from "store";
import dayjs from "dayjs";
import _, { isEmpty } from "lodash";

export const getMax = (arr = []) => {
  let max;
  arr.forEach((e, i) => {
    if (i === 0) {
      max = e;
    }
    if (max < e) {
      max = e;
    }
  });
  return max;
};

export const cleanBlankValue = (obj) => {
  Object.keys(obj).forEach((key) => {
    if (
      obj[key] === null ||
      obj[key] === undefined ||
      obj[key] === "" ||
      (Array.isArray(obj[key]) && obj[key].length === 0)
    ) {
      delete obj[key];
    }
  });

  return obj;
};

export const compareWithJSON = (prevProps, nextProps) => {
  try {
    return JSON.stringify(prevProps) === JSON.stringify(nextProps);
  } catch {
    return true;
  }
};

export const stripHTMLTag = (str = "") => {
  return str.replace(/<br \/>/g, "\n").replace(/(<([^>]+)>)/gi, "");
};

export const updateObject = (oldObject, updatedProperties) => {
  return {
    ...oldObject,
    ...updatedProperties,
  };
};

// Key for list
export const keyExtractor = (item, index) => `${index}`;

export const generateBaseUri = () => {
  // Jika env base url di bypass
  const byPassEndpoint = localStore.get("app.bypassEndpoint");
  if (localStore.get("app.isOverwriteBaseUrl") && !!byPassEndpoint) {
    return byPassEndpoint;
  }

  let apiUrl = process.env.REACT_APP_API_URL;
  let baseUrl = apiUrl
    ? apiUrl.replace(/^(?:https?:\/\/)?(?:www\.)?/i, "")
    : "";
  const hostname = window.location.hostname;
  if (process.env.NODE_ENV === "production") {
    const splitHostname = hostname.split(".");
    if (splitHostname[0] && localStore.get("app.endpoint")) {
      baseUrl = `${splitHostname[0]}.${baseUrl}`;
    }
  }

  let protocol = _.includes(apiUrl, "https://") ? "https://" : "http://";
  if (_.includes("local.jokolodang.com", hostname)) {
    protocol = "http://";
  }
  if (localStore.get("app.endpoint")) {
    apiUrl = `${protocol}${localStore.get("app.endpoint")}/api/v1`;
  } else {
    apiUrl = `${protocol}${baseUrl}`;
    if (_.includes("localhr.jokolodang.com", hostname)) {
      apiUrl = `http://app.kledo.test/api/v1`;
    } else if (_.includes("localsslhr.jokolodang.com", hostname)) {
      apiUrl = `https://app.kledo.test/api/v1`;
    }
  }

  return apiUrl;
};

// Filter for select antd
export const filterOption = (input, option) => {
  if (
    option?.label &&
    typeof input === "string" &&
    typeof option?.label === "string"
  ) {
    return (option?.label || "")
      .toLocaleLowerCase()
      .includes(input.toLocaleLowerCase());
  } else if (option?.children)
    return (
      option.children.toString().toLowerCase().indexOf(input.toLowerCase()) >= 0
    );
  return true;
};

export const generateEndpoint = (url) => `${generateBaseUri()}${url}`;

// Get base64 image
export const getBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
};

// Get dimension of image
export const getDimensions = (file) => {
  return new Promise((resolve, reject) => {
    const img = document.createElement("img");
    img.onload = () => {
      resolve({
        height: img.naturalHeight,
        width: img.naturalWidth,
      });
    };
    img.onerror = reject;

    const reader = new FileReader();
    reader.onloadend = (ended) => {
      img.src = ended.target.result;
    };
    reader.readAsDataURL(file);
  });
};

//generate card character by firstname and lastname
export const generateCardName = (name) => {
  const fullName = name.split(" ");
  if (fullName.length > 2) {
    return `${fullName[0].slice(0, 1)}${fullName[2].slice(0, 1)}`;
  } else if (fullName.length > 1) {
    return `${fullName[0].slice(0, 1)}${fullName[1].slice(0, 1)}`;
  } else {
    return `${fullName[0].slice(0, 1)}`;
  }
};

export const generateDayNames = (locale = "id-ID") => {
  return Array.from({ length: 7 }, (_, i) =>
    dayjs()
      .startOf("week")
      .add(locale === "id-ID" ? i : i + 1, "day")
      .format("dddd")
  );
};

export const openNewTab = (moduleUrl = "", withBaseUri = true) => {
  const tempLink = document.createElement("a");
  if (withBaseUri) tempLink.href = `${generateBaseUri()}${moduleUrl}`;
  else tempLink.href = moduleUrl;
  tempLink.setAttribute("target", "_blank", "noopener");
  tempLink.click();
};

export const findHrCompanies = (companies = []) => {
  if (!Array.isArray(companies)) {
    return [];
  }
  const filteredCompanies = (companies || []).filter((company) => {
    let apps = company?.apps || [];
    if (!Array.isArray(apps) && typeof apps === "object") {
      apps = Object.values(apps);
    }
    if (Array.isArray(apps)) {
      apps = apps.filter((app) => app.code === "hr").length > 0;
    }
    return apps;
  });

  return filteredCompanies;
};

export const isFeature = ({ billing, code }) =>
  billing?.hidden_feature &&
  _.isArray(billing?.hidden_feature) &&
  (billing?.hidden_feature || [])?.filter((e) => e === code).length > 0;

export const generateCountData = (
  min,
  max,
  range,
  includeMax = false,
  initialFirst
) => {
  const list = [];
  const arrayData = new Array((max - min) / range).fill("count");
  arrayData.map((e, index) => {
    if (index === 0) {
      return list.push(min);
    }
    return list.push(list[index - 1] + range);
  });
  if (initialFirst) {
    list.unshift(initialFirst);
  }
  if (includeMax) {
    list.push(max);
  }
  return list;
};

export const copyclip = (text) => {
  const textField = document.createElement("textarea");
  textField.innerText = text;
  document.body.appendChild(textField);
  textField.select();
  document.execCommand("copy");
  textField.remove();
};

export const parseMinutes = (x) => {
  const hours = Math.floor(x / 60);
  const minutes = x % 60;
  return {
    hours,
    minutes,
  };
};

export const parseHours = (x) => {
  if (!x) {
    return null;
  }
  const valueMinutes = parseFloat(x) * 60;
  const hours = Math.floor(valueMinutes / 60);
  const minutes = Math.floor(valueMinutes % 60);
  return {
    hours,
    minutes,
  };
};

export const parsePeriod = (
  t,
  dateStarted,
  dateEnded,
  withYear = true,
  withMonth = true,
  withDay = true
) => {
  if (!dateStarted || !dateEnded) {
    return "-";
  }

  const start = dayjs(dateStarted);
  const end = dayjs(dateEnded);

  if (!start.isValid() || !end.isValid()) {
    return "-";
  }

  // If start date is after end date, return "0 days"
  if (start.isAfter(end)) {
    return `0 ${t("date.days")}`;
  }

  // Calculate differences manually for more accuracy
  let years = end.year() - start.year();
  let months = end.month() - start.month();
  let days = end.date() - start.date();

  // Adjust for negative days
  if (days < 0) {
    months--;
    days += start.daysInMonth();
  }

  // Adjust for negative months
  if (months < 0) {
    years--;
    months += 12;
  }

  // Build the result string
  const parts = [];

  if (withYear && years > 0) {
    parts.push(`${years} ${t("date.year")}`);
  }

  if (withMonth && months > 0) {
    parts.push(`${months} ${t("date.month")}`);
  }

  if (withDay && days > 0) {
    const dayLabel = days === 1 ? t("employee.day") : t("date.days");
    parts.push(`${days} ${dayLabel}`);
  }

  // Handle edge case where difference is less than a day
  if (parts.length === 0 && withDay) {
    const hoursDiff = end.diff(start, "hour");
    if (hoursDiff > 0) {
      parts.push(`1 ${t("employee.day")}`);
    } else {
      parts.push(`0 ${t("date.days")}`);
    }
  }

  return parts.length > 0 ? parts.join(" ") : "-";
};

export const monthToYearsAndMonths = (months) => {
  const years = Math.floor(months / 12);
  const remainingMonths = months % 12;

  return {
    years,
    months: remainingMonths,
  };
};

export const monthToMonthsAndDays = (months) => {
  const wholeMonths = Math.floor(months);
  const days = Math.round((months - wholeMonths) * 30); // Approximate days

  return {
    months: wholeMonths,
    days,
  };
};

export const parsePaginateData = (data, withDetail) => {
  const pageData = [];
  let pageDetail = { data: [], total: 0 };
  if (!data) {
    return withDetail ? pageDetail : pageData;
  }
  if (data && Array.isArray(data?.pages)) {
    data.pages.forEach((page) => {
      if (withDetail) {
        pageDetail.total = page?.total || 0;
        (page?.data || []).forEach((row) => {
          pageDetail.data.push(row);
        });
      } else {
        if (Array.isArray(page?.data)) {
          (page?.data || []).forEach((row) => {
            pageData.push(row);
          });
        }
      }
    });
  }
  return withDetail ? pageDetail : pageData;
};

export const parseAttachmentsData = (data) => {
  if (!data) {
    return [];
  }
  const dataAttachments = (data || []).map((item, index) => ({
    ...item,
    uid: `uid-${index}`,
    name: item?.file_name || `attachments-${index + 1}`,
    status: "done",
  }));
  return dataAttachments;
};

export const formatAttachmentsToDB = (data) => {
  if (!data || !Array.isArray(data)) {
    return [];
  }
  const formatted = data
    .filter((row) => !!row?.attachment_url || !!row?.original_url || !!row?.url)
    .map((item) => item?.attachment_url || item?.original_url || item?.url);

  return formatted;
};

export const parseTotalPaginateData = (data) => {
  let total = 0;
  if (!data) {
    return total;
  }
  if (data && !_.isEmpty(data?.pages)) {
    total = data.pages?.[0]?.total || 0;
  }
  return total;
};

export const parseArrayParams = (data) => {
  const params = _.cloneDeep(data);
  let parseParams = [];
  try {
    parseParams = params ? JSON.parse(decodeURIComponent(params)) : [];
  } catch (error) {
    parseParams = [];
  }

  // Replace back the ampersand in array items
  const formattedParams = Array.isArray(parseParams)
    ? parseParams.map((row) => {
        if (row?.label) {
          row.label = row.label.replace(/__AMP__/g, "&");
        }
        if (row?.name) {
          row.name = row.name.replace(/__AMP__/g, "&");
        }
        return row?.value ? row?.value : row;
      })
    : [];
  return formattedParams;
};

export const parseUriToArrayParams = (data) => {
  const params = _.cloneDeep(data);
  let parseParams = [];
  try {
    parseParams = params ? JSON.parse(decodeURIComponent(params)) : [];
  } catch (error) {
    parseParams = [];
  }

  // Replace back the ampersand in array items
  const formattedParams = Array.isArray(parseParams)
    ? parseParams.map((row) => {
        if (row?.label) {
          row.label = row.label.replace(/__AMP__/g, "&");
        }
        if (row?.name) {
          row.name = row.name.replace(/__AMP__/g, "&");
        }
        if (row?.id) {
          row.value = row.id;
        }
        return row;
      })
    : [];
  return formattedParams;
};

export const parseObjectParams = (data) => {
  const params = _.cloneDeep(data);
  let parseParams = {};
  try {
    parseParams = params ? JSON.parse(params) : {};
  } catch (error) {
    parseParams = {};
  }
  if (parseParams.value === 0 || parseParams.value === "0") {
    parseParams.value = null;
  }

  // Replace back the ampersand
  const label = parseParams?.label
    ? parseParams.label.replace(/__AMP__/g, "&")
    : "";
  const name = parseParams?.name
    ? parseParams.name.replace(/__AMP__/g, "&")
    : "";

  return {
    name: name || label || "",
    label: label || name || "",
    value: parseParams?.value || null,
  };
};

//parse to uri multiple setting filter
export const parseMultipleFilterSettingToUri = (key, name, setting) => {
  if (name && key && setting) {
    const filters = {
      [name]: [],
    };
    if (Array.isArray(setting?.[name]) && !_.isEmpty(setting?.[name])) {
      filters[name] = setting[name].map((row) => ({
        label: row?.name?.replace(/&/g, "__AMP__"),
        value: row?.id,
      }));

      const parseToUri = encodeURIComponent(JSON.stringify(filters[name]));
      return `${key}=${parseToUri}`;
    } else if (
      typeof setting?.[name] === "object" &&
      !_.isEmpty(setting?.[name])
    ) {
      filters[name] = {
        label: setting[name]?.name?.replace(/&/g, "__AMP__"),
        value: setting[name]?.id,
      };

      const parseToUri = JSON.stringify(filters[name]);
      return `${key}=${parseToUri}`;
    } else {
      if (!_.isEmpty(setting?.[name])) {
        filters[name] = setting[name];
        return `${key}=${filters[name]}`;
      }
    }
  }
  return "";
};

export const createMockData = (count = 3) => {
  const data = [];
  for (let i = 0; i <= count - 1; i++) {
    data.push({ id: i });
  }

  return data;
};

//color default approval status
export const colorApprovalStatus = (id) => {
  switch (id) {
    case 1:
      return "#FFE0A3";
    case 2:
      return "#D9F489";
    case 3:
      return "#FFA1AC";
    case 4:
      return "#F2994A";
    default:
      return "#FFFFFF";
  }
};

//color default status on cash receipt
export const colorCashReceiptStatus = (id) => {
  switch (id) {
    case 1:
      return "#FFE0A3";
    case 2:
      return "#D9F489";
    case 3:
      return "#FFA1AC";
    case 4:
      return "#46be8a";
    case 5:
      return "#59DD8E";
    case 6:
      return "#E85077";
    default:
      return "#FFFFFF";
  }
};

//key down only allowed number only
export const keyDownNumberOnly = (event) => {
  const allowedKeys = [
    "0",
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    "Backspace",
    "ArrowLeft",
    "ArrowRight",
    "Delete",
    "Del",
  ];
  if (!allowedKeys.includes(event.key) && !event.ctrlKey) {
    event.preventDefault();
  }
};

/**
 * Determine the mobile operating system.
 * This function returns one of 'ios', 'android', 'windows_phone', or 'other'.
 *
 * @returns {String}
 */
export const getMobileOperatingSystem = () => {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;

  // Windows Phone must come first because its UA also contains "Android"
  if (/windows phone/i.test(userAgent)) {
    return "windows_phone";
  }

  if (/android/i.test(userAgent)) {
    return "android";
  }

  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    return "ios";
  }

  return "other";
};

export function showObjectsWithUniqueProperties(arr, prop1, prop2) {
  return arr.filter((item, index, self) => {
    return (
      index ===
      self.findIndex(
        (t) => t[prop1] === item[prop1] && t[prop2] === item[prop2]
      )
    );
  });
}

export const formatPageParams = (value, defaultValue) => {
  if (value === undefined || value === null || !value) {
    if (typeof defaultValue === "string") {
      const parsedDefault = parseInt(defaultValue, 10);
      return isNaN(parsedDefault) ? defaultValue : parsedDefault;
    }
    return defaultValue;
  }
  if (typeof value === "string") {
    const parsedValue = parseInt(value, 10);
    if (!isNaN(parsedValue)) {
      return parsedValue;
    }
    const parsedDefault = parseInt(defaultValue, 10);
    return isNaN(parsedDefault) ? defaultValue : parsedDefault;
  }
  return value;
};

export function rgbaToObject(rgbaString) {
  // Remove "rgba(" and ")" and split the values
  const [r, g, b, a] = rgbaString
    .replace("rgba(", "")
    .replace(")", "")
    .split(", ")
    .map((value) =>
      value.includes(".") ? parseFloat(value) : parseInt(value, 10)
    );

  // Return as an object
  return { r, g, b, a };
}

export function isValidRgba(rgbaString) {
  const rgbaRegex =
    /^rgba\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(0|0?\.\d+|1)\s*\)$/;
  const match = rgbaString.match(rgbaRegex);

  if (!match) return false;

  // Extract RGB values and ensure they are in the valid range (0-255)
  const [, r, g, b, a] = match;
  return (
    r >= 0 &&
    r <= 255 &&
    g >= 0 &&
    g <= 255 &&
    b >= 0 &&
    b <= 255 &&
    a >= 0 &&
    a <= 1
  );
}

export const generateSequence = (min, max) => {
  if (min > max) {
    throw new Error("Min value cannot be greater than max value");
  }

  const sequence = [];
  for (let i = min; i <= max; i++) {
    sequence.push(i);
  }

  return sequence;
};

export const fixNestedLists = (htmlString) => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(htmlString, "text/html");
  const ulElements = doc.querySelectorAll("ul ul");

  ulElements.forEach((nestedUl) => {
    const parentLi = nestedUl.previousElementSibling;
    if (parentLi && parentLi.tagName === "LI") {
      parentLi.appendChild(nestedUl); // Move the <ul> inside the previous <li>
    }
  });

  return doc.body.innerHTML; // Return the corrected HTML
};

export const validateName = ({
  value,
  validateCapital = false,
  capitalMessage,
  offensiveMessage,
}) => {
  if (!value) {
    return Promise.resolve();
  }

  // Validasi tidak boleh huruf besar semua
  if (validateCapital) {
    if (value === value.toUpperCase() && value.length > 0) {
      return Promise.reject(capitalMessage);
    }
  }

  // Validasi kata-kata kasar
  const offensiveWords = [
    "anjing",
    "fuck",
    "bangsat",
    "kontol",
    "memek",
    "jembut",
    "bajingan",
    "goblok",
    "bodoh",
    "tolol",
    "idiot",
    "dungu",
    "perek",
    "jablay",
    "lacur",
    "pukimak",
    "pepek",
    "ngentot",
    "entot",
    "setan",
    "pantat",
    "pelacur",
    "anjeng",
    "kampret",
    "keparat",
    "brengsek",
    "kunyuk",
    "monyet",
    "peler",
    "titit",
    "ngewe",
    "dancok",
    "jancok",
    "jancuk",
  ];

  // Words that need word boundary checking (to avoid false positives)
  const wordBoundaryWords = [
    "babi",
    "bego",
    "asu",
    "asoe",
    "kimak",
    "lonte",
    "tai",
    "shit",
    "damn",
  ];

  const lowerValue = value.toLowerCase();

  // Check regular offensive words
  const hasOffensiveWord = offensiveWords.some((word) =>
    lowerValue.includes(word)
  );

  // Check word boundary words using regex
  const hasWordBoundaryOffensive = wordBoundaryWords.some((word) => {
    const regex = new RegExp(`\\b${word}\\b`, "i");
    return regex.test(lowerValue);
  });

  // Check specific patterns
  const hasPatternOffensive = /\ban\s+jing\b/i.test(lowerValue);

  if (hasOffensiveWord || hasWordBoundaryOffensive || hasPatternOffensive) {
    return Promise.reject(offensiveMessage);
  }

  return Promise.resolve();
};

export const isPhoneNumber = (value) => {
  if (!value || typeof value !== "string") return false;
  // Check for various phone number patterns
  const phonePatterns = [
    /^\d{10,15}$/, // 10-15 digits only
    /^\+\d{10,15}$/, // + followed by 10-15 digits
    /^\d{3,4}[-.\s]\d{3,4}[-.\s]\d{3,6}$/, // formatted with separators
  ];
  return phonePatterns.some((pattern) =>
    pattern.test(value.replace(/\s/g, ""))
  );
};

export const isValidDateTime = (value) => {
  if (!value || isPhoneNumber(value)) return false;

  // Check if it looks like a date/datetime format first
  const dateTimePatterns = [
    /^\d{4}-\d{1,2}-\d{1,2}$/, // YYYY-MM-DD
    /^\d{4}-\d{1,2}-\d{1,2}\s\d{1,2}:\d{1,2}$/, // YYYY-MM-DD HH:mm
    /^\d{4}-\d{1,2}-\d{1,2}\s\d{1,2}:\d{1,2}:\d{1,2}$/, // YYYY-MM-DD HH:mm:ss
    /^\d{4}-\d{1,2}-\d{1,2}T\d{1,2}:\d{1,2}/, // ISO format
    /^\d{1,2}\/\d{1,2}\/\d{4}$/, // MM/DD/YYYY or DD/MM/YYYY
    /^\d{1,2}-\d{1,2}-\d{4}$/, // MM-DD-YYYY or DD-MM-YYYY
    /^\d{4}\/\d{1,2}\/\d{1,2}$/, // YYYY/MM/DD
  ];

  const looksLikeDateTime = dateTimePatterns.some((pattern) =>
    pattern.test(value)
  );
  return looksLikeDateTime && dayjs(value).isValid();
};

export const decodeUriWithAtob = (search) => {
  if (!isEmpty(search)) {
    let params = search;
    if (!isEmpty(params)) {
      try {
        const decodedString = atob(params || "");
        return JSON.parse(decodeURIComponent(decodedString));
      } catch {
        return {};
      }
    }
  }
  return {};
};

export const encodeUriWithBtoa = (params) => {
  if (!isEmpty(params)) {
    const queryString = JSON.stringify(params);
    const encodedString = encodeURIComponent(queryString);
    return btoa(encodedString);
  }
  return "";
};
